import { IonToast } from "@ionic/react";
import { useEffect, useState } from "react";

import {
  APP_UPDATE_AVAILABLE_EVENT,
} from "src/utils/swUpdateEvents";
import { applyPendingUpdate } from "src/utils/versionCheck";

const UpdateAvailableToast: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [applying, setApplying] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(APP_UPDATE_AVAILABLE_EVENT, handler);
    return () => window.removeEventListener(APP_UPDATE_AVAILABLE_EVENT, handler);
  }, []);

  const onActualizar = async () => {
    if (applying) return;
    setApplying(true);
    await applyPendingUpdate();
  };

  return (
    <IonToast
      isOpen={open}
      message={
        applying
          ? "Actualizando..."
          : "Hay una version nueva disponible."
      }
      position="top"
      color="primary"
      buttons={
        applying
          ? []
          : [
              {
                text: "Actualizar",
                role: "info",
                handler: () => {
                  void onActualizar();
                  return false;
                },
              },
              {
                text: "Despues",
                role: "cancel",
                handler: () => setOpen(false),
              },
            ]
      }
    />
  );
};

export default UpdateAvailableToast;
